//#region src/semantic.ts
const EVENT_CLICK = "click";
const EVENT_NAVIGATION = "navigation";
const EVENT_VIEW_CHANGED = "view_changed";
const EVENT_SESSION_START = "session_start";
const EVENT_SESSION_RESUME = "session_resume";
const EVENT_SESSION_EXTEND = "session_extend";
const EVENT_OVERRIDES_SERVICE_NAME = "service_name_override";
const EVENT_ROUTE_CHANGE = "route_change";
//#endregion
export { EVENT_CLICK, EVENT_NAVIGATION, EVENT_OVERRIDES_SERVICE_NAME, EVENT_ROUTE_CHANGE, EVENT_SESSION_EXTEND, EVENT_SESSION_RESUME, EVENT_SESSION_START, EVENT_VIEW_CHANGED };

//# sourceMappingURL=semantic.js.map